import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { LogoLoader } from '@/components/ui/logo-loader';
import { apiClient } from '@/lib/api-client';
import { useCurrentUser } from '@/hooks/use-current-user';

export default function ProvisioningPendingPage() {
  const { t } = useTranslation('common');
  const [location, setLocation] = useLocation();
  const queryClient = useQueryClient();
  const { user } = useCurrentUser();
  const organizationId = (user as any)?.organizationId as string | undefined;

  const statusQuery = useQuery({
    queryKey: ['org', 'provisioning-status', organizationId ?? 'current'],
    queryFn: () => apiClient.getCurrentProvisioningStatus(organizationId),
    enabled: Boolean(user),
    refetchInterval: 5000,
  });

  const status = statusQuery.data?.data?.status ?? (user as any)?.orgProvisioningStatus;

  useEffect(() => {
    if (status === 'ready') {
      // Refresh auth/me so ProtectedRoute gets updated provisioning fields
      // and performs the final navigation to the main app route.
      void queryClient.invalidateQueries({ queryKey: ['auth', 'me'] });
    } else if (status === 'failed' && location !== '/provisioning-failed') {
      setLocation('/provisioning-failed');
    }
  }, [location, queryClient, setLocation, status]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="card-container w-full max-w-lg p-8 text-center space-y-4">
        <div className="flex justify-center">
          <LogoLoader size="lg" />
        </div>
        <h1 className="text-lg font-semibold text-[#333333]">
          {t('provisioning.pendingTitle')}
        </h1>
        <p className="text-sm text-[#666666]">
          {t('provisioning.pendingMessage')}
        </p>
      </div>
    </div>
  );
}
